module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-creative-02.fabcd433.jpg";